export interface ProgressListOptions {
    label?: string;
    format?: ProgressListFormat;
}

export type ProgressListFormat = "filesize" | "count";

export class ProgressList {
    public onChange = e5.Signal.create();
    public onAdd = e5.Signal.create();

    private _items: ProgressListItem[] = [];
    private _options: ProgressListOptions;

    constructor(options: ProgressListOptions = {}) {
        this._options = e5.object.merge({
            label: "",
            format: "count"
        }, options);
    }


    public get label(): string {
        return this._options.label;
    }

    public get text(): string {
        if (this._options.format === "filesize") {
            return e5.Text.fileSize(this.loaded, false) + " von " + e5.Text.fileSize(this.total, false);
        }
        else if (this._options.format === "count") {
            return this.loaded + " von " + this.total;
        }
        return "";
    }

    public add(total: number): ProgressListItem {
        let item = new ProgressListItem(this);
        item.total = total;
        this.onAdd.dispatch();
        this._items.push(item);
        return item;
    }

    public get loaded(): number {
        let loaded = 0;
        for (let item of this._items) {
            loaded += item.loaded;
        }
        return loaded;
    }

    public get total(): number {
        let total = 0;
        for (let item of this._items) {
            total += item.total;
        }
        return total;
    }
}

export class ProgressListItem {
    constructor(private _list: ProgressList) { }

    public loaded: number = 0;
    public total: number = 0;

    public update(loaded: number, total: number): void {
        if (!this._list) {
            return;
        }
        this.loaded = loaded;
        this.total = total;
        this._list.onChange.dispatch();
    }
}

